import { render, staticRenderFns } from "./ModalConfigurationViewer.vue?vue&type=template&id=0c8fafeb&scoped=true&"
import script from "./ModalConfigurationViewer.vue?vue&type=script&lang=js&"
export * from "./ModalConfigurationViewer.vue?vue&type=script&lang=js&"
import style0 from "./ModalConfigurationViewer.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./ModalConfigurationViewer.vue?vue&type=style&index=1&id=0c8fafeb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c8fafeb",
  null
  
)

export default component.exports